<!-- 策略客户操作 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle"  append-to-body :close-on-click-modal="false" center  width="50%" top="2rem">
			<el-form size="mini" label-position="top" label-width="120px">
				<el-form-item label="归属分组">
					<el-input v-model.trim="sendDataInfo.cmgroupName" @focus="$refs['showSelectData'].openBox('customerGroupList','customerGroupList','cmgroupId')"></el-input>
				</el-form-item>
				<el-form-item label="客户列表" v-if="dataActionBox.actionType==0">
					<div style="margin:.2rem 0">
						<el-button type="success"  @click="$refs['showSelectData'].openBox('customerList','customerList','cmId')">新增客户</el-button>
					</div>
					<el-table :data="sendDataInfo.userList"  height="320"   border  style="width: 100%">
						<el-table-column label="操作" width="80">
							<template  slot-scope="scope">
								<el-button type="primary" @click="delListInfo(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					    <el-table-column  prop="cmName" label="客户名称">
					    </el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item label="客户名称" v-if="dataActionBox.actionType==1">
					<el-input v-model.trim="sendDataInfo.cmName" disabled></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0||dataActionBox.actionType==1">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'customerStrategyAction',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
				"cmIds": [],
				"cmgroupId": "",
				cmgroupName:"",
				userList:[],
				cmId:"",
				id:"",
				cmName:"",
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		delListInfo(index){
			this.sendDataInfo.userList.splice(index,1)
		},
	
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			this.sendDataInfo.cmIds = [];
			this.sendDataInfo.userList = [];
			
		},
		
		isShowData(name,value){
			switch(name){
				case 'customerGroupList':
					var dataInfo = sessionStorage.getItem('selectCustomerGroupData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.sendDataInfo.cmgroupId = dataInfo.cmgroupId
						this.sendDataInfo.cmgroupName = dataInfo.cmgroupName
					}
					
				break;
				
				case 'customerList':
					var dataInfo = sessionStorage.getItem('selectCustomerData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						var isPushData = true
						this.sendDataInfo.userList.forEach((item,keys)=>{
							if(item.cmId == dataInfo.cmId){
								this.$message({
									message: '客户已存在此分组，请勿重复添加',
									type: 'error'
								});
								isPushData = false
								return false
							}
						})
						if(isPushData==true){
							this.sendDataInfo.userList.push(dataInfo)
						}
						
					}
					
				break;
				default:
					this.sendDataInfo[name] = value
				
			}
		},
		
	
		
		openBox(cate,oldData=''){
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增策略客户'
			}else{
				this.dataActionBox.boxTitle = '编辑策略客户'
				this.sendDataInfo  = oldData
			
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			if(this.sendDataInfo.cmgroupId==''){
				this.$message({
					message: '请选择客户分组',
					type: 'error'
				});
				return false
			}
			if( this.dataActionBox.actionType==0 && this.sendDataInfo.userList.length<=0){
				this.$message({
					message: '请选择客户',
					type: 'error'
				});
				return false
			}
			
			var newSendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
			
			if(this.dataActionBox.actionType==0){
				newSendDataInfo.userList.forEach((item,keys)=>{
					newSendDataInfo.cmIds.push(item.cmId)
				})
				var responseData =  await this.$http.addStrategyCustomers(newSendDataInfo)
			}else{
				var responseData =  await this.$http.setStrategyCustomers(newSendDataInfo)
			}
			
			
			if(responseData.status == 200){
				this.dataActionBox.showStatus = false
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>